import React from 'react';
import { Mfa as MfaComponent } from '~/components/Auth/Mfa';

export function Mfa() {
    return (
        <div className="container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <MfaComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
